// Tab içeriklerini göster/gizle ve 'tümünü gör' butonunun linkini güncelle
function productsWithTabsSeeAllBtnInit() {
  var seeAllBtn = document.getElementById('products-with-tabs-see-all-btn');
  if (!seeAllBtn) return;

  function updateSeeAllBtn() {
    // Önce aria-selected="true" ile bul, yoksa .button--secondary ile bul
    var activeTab = document.querySelector('.products-with-tabs__tab[aria-selected="true"]')
      || document.querySelector('.products-with-tabs__tab.button--secondary')
      || document.querySelector('.products-with-tabs__tab.is-active')
      || document.querySelector('.products-with-tabs__tab.active');
    if (activeTab) {
      var url = activeTab.getAttribute('data-collection-url');
      if (url) {
        seeAllBtn.setAttribute('href', url);
        seeAllBtn.removeAttribute('disabled');
      } else {
        seeAllBtn.setAttribute('href', '#');
        seeAllBtn.setAttribute('disabled', 'disabled');
      }
      // Konsola aktif linki yaz
      console.log('Aktif tab koleksiyon linki:', url);
    }
  }

  // Sayfa yüklenince ilk linki ayarla
  updateSeeAllBtn();

  // Aktif tabı ve linki sürekli kontrol et (her 200ms)
  var lastUrl = null;
  setInterval(function() {
    var activeTab = document.querySelector('.products-with-tabs__tab.button--secondary');
    if (activeTab) {
      var url = activeTab.getAttribute('data-collection-url');
      if (url !== lastUrl) {
        lastUrl = url;
        if (url) {
          seeAllBtn.setAttribute('href', url);
          seeAllBtn.removeAttribute('disabled');
        } else {
          seeAllBtn.setAttribute('href', '#');
          seeAllBtn.setAttribute('disabled', 'disabled');
        }
        console.log('Aktif tab koleksiyon linki:', url);
      }
    }
  }, 200);
}

document.addEventListener('DOMContentLoaded', productsWithTabsSeeAllBtnInit);
document.addEventListener('shopify:section:load', productsWithTabsSeeAllBtnInit);

// Desktop: mouse wheel scrolls category tabs horizontally
function initTabsWheelScroll(root) {
  if (!root) root = document;
  var wrappers = root.querySelectorAll('.products-with-tabs__tabs-wrapper');
  var isDesktop = window.matchMedia('(min-width: 990px)').matches;
  wrappers.forEach(function (el) {
    if (el.dataset.wheelScrollInited) return;
    el.dataset.wheelScrollInited = '1';
    el.addEventListener('wheel', function (e) {
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      var maxScroll = el.scrollWidth - el.clientWidth;
      if (maxScroll <= 0) return;
      if (e.deltaY === 0) return;
      e.preventDefault();
      el.scrollLeft += e.deltaY;
    }, { passive: false });
  });
}
document.addEventListener('DOMContentLoaded', function () { initTabsWheelScroll(); });
document.addEventListener('shopify:section:load', function (e) { initTabsWheelScroll(e.target); });

// Tab değiştiğinde buton linkini güncelle
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.products-with-tabs__tab');
  const viewAllButton = document.querySelector('.products-with-tabs__view-all');
  
  if (viewAllButton && tabs.length > 0) {
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const collectionUrl = this.getAttribute('data-collection-url');
        if (collectionUrl) {
          viewAllButton.setAttribute('href', collectionUrl);
        }
      });
    });
    
    // İlk tab'ın collection URL'sini başlangıçta ata
    const firstTab = tabs[0];
    const firstCollectionUrl = firstTab.getAttribute('data-collection-url');
    if (firstCollectionUrl) {
      viewAllButton.setAttribute('href', firstCollectionUrl);
    }
  }
});
(()=>{let o=t=>{if(t){var s=t.parentNode.parentNode.querySelector(".products-with-tabs__navigation"),r=t.querySelector(".products-with-tabs__pagination"),a=Number(t.dataset.columns),i=a,o=4<=a?i-1:i,c=3<=a?3:i,n=2<=a?2:c;let e=1;t.classList.contains("products--2-mobile")&&(e=1<a?2:1),new Swiper(t,{slidesPerView:e,slidesPerGroup:e,spaceBetween:8,mousewheel:{forceToAxis:!0},navigation:{nextEl:s.querySelector(".swiper-button-next"),prevEl:s.querySelector(".swiper-button-prev")},pagination:{el:r,type:"custom",clickable:!0,renderCustom:function(e,t,s){let r="";for(let e=1;e<s+1;e++)r=e==t?`${r}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`:`${r}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;return r}},breakpoints:{576:{slidesPerView:n,slidesPerGroup:n,spaceBetween:8},750:{slidesPerView:c,slidesPerGroup:c,spaceBetween:8},990:{slidesPerView:o,slidesPerGroup:o,spaceBetween:8},1200:{slidesPerView:i,slidesPerGroup:i,spaceBetween:24},1600:{slidesPerView:a,slidesPerGroup:a,spaceBetween:24}}})}},c=e=>{e&&e.querySelectorAll(".products-with-tabs__slider").forEach(e=>{e.swiper&&e.swiper.destroy()})},t=i=>{if(i&&i.classList.contains("products-with-tabs-section")){let a=i.querySelectorAll(".products-with-tabs__tab");a.forEach(s=>{let r=s.dataset.productTab;s.addEventListener("click",e=>{var t;e.currentTarget.classList.contains("button--secondary")||(a.forEach(e=>{e.classList.remove("button--secondary"),e.classList.add("button--tertiary")}),s.classList.remove("button--tertiary"),s.classList.add("button--secondary"),e=i,t=r,e&&(e.querySelectorAll(".products-with-tabs__products").forEach(e=>{e.classList.remove("products-with-tabs__products--active")}),c(e),e=e.querySelector(`[data-product-tab="${t}"].products-with-tabs__products`))&&(e.classList.add("products-with-tabs__products--active"),e.classList.contains("products-with-tabs__slider"))&&o(e))})})}},s=e=>{e&&e.classList.contains("products-with-tabs-section")&&(e=e.querySelector(".products-with-tabs__slider.products-with-tabs__products--active"))&&o(e)};s(document.currentScript.parentElement),t(document.currentScript.parentElement),document.addEventListener("shopify:section:load",function(e){s(e.target),t(e.target)})})();